// src/cert/iso21001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO21001 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 21001 प्रमाणन</h1>
                <p>शैक्षणिक संस्था व्यवस्थापन प्रणाली (Educational Organizations Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO 21001 म्हणजे काय?</h2>
                    <p>
                        ISO 21001 is an International Standard that specifies requirements for an Educational Organizations Management System (EOMS). This standard provides a common management tool for organizations that offer educational products and services, regardless of their type, size, or method of delivery. The primary goal of ISO 21001 is to help educational institutions—such as schools, colleges, training centers, and other providers of educational services—establish an effective management system that is focused on meeting the needs and expectations of their students, teachers, and parents (beneficiaries). It emphasizes the importance of social responsibility and ethical conduct in education, ensuring that the entire learning process and output are consistent, effective, and contribute to the achievement of organizational objectives, thereby enhancing the satisfaction of the learners and other stakeholders.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>शिक्षणाची गुणवत्ता सुधारते</li>
                        <li>विद्यार्थी समाधान आणि यश वाढते</li>
                        <li>प्रक्रिया सुव्यवस्थित होतात (प्रवेश, मूल्यमापन, अभ्यासक्रम)</li>
                        <li>शिक्षक आणि कर्मचाऱ्यांचा विकास होतो</li>
                        <li>संस्थेची प्रतिष्ठा आणि मान्यता वाढते</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 21001 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 21001" />
                </section>
            </div>
        </div>
    );
};

export default ISO21001;